const ResultTypes = Object.freeze({
    File: "file",
    ProtocolHandler: "protocol",
    Browser: "browser",
});

const MimeTypes = Object.freeze({
    Text: "text/plain",
    Json: "application/json",
    Html: "text/html",
    Ica: "application/x-ica",
});

const Headers = Object.freeze({
    ResultType: "X-Result-Type",
    ProtocolType: "X-Protocol-Type",
    MimeType: "Content-Type",
    DownloadName: "X-Download-Name",
});

const Protocols = Object.freeze({
    CitrixClient: "citrix",
    CitrixBrowser: "browser",
    RDP: "rdp",
    ParallelsClient: "parallels_client",
    ParallelsBrowser: "parallels_browser",
    DcvClientFile: "dcv_client_file",
    DcvClientHandler: "dcv_client_protocol_handler",
    DcvBrowser: "dcv_browser",
});

const ProtocolLabels = Object.freeze({
    CitrixClient: "Citrix Receiver",
    CitrixBrowser: "Citrix Browser",
    RDP: "RDP",
    ParallelsClient: "Parallels Client",
    ParallelsBrowser: "Parallels Browser",
    DcvClientFile: "DCV Client - File",
    DcvClientHandler: "DCV Client",
    DcvBrowser: "DCV Browser",
});

const ProgressText = Object.freeze({
    ParallelsClient: "Attempting to launch Bloomberg Anywhere",
    DcvClientHandler: "Attempting to launch DCV Client",
    Browser: "Launching Bloomberg Terminal in a new tab",
    getFileProgressText: (fileName) =>
        `Open downloaded ${fileName} file to launch Bloomberg Terminal`,
});

const DefaultProgressText = Object.freeze("Launching, please wait...");

// FAQ for managed Macs, deep-linked to the managed-Mac question.
const MigrationFaqUrl = Object.freeze(
    "https://cms.prod.bloomberg.com/team/spaces/rpd/pages/4220454109/" +
        "BBA+Migration+to+Parallels+RAS+FAQ#BBAMigrationtoParallelsRASFAQ-" +
        "I'monamanagedMac%2CbutIdon'tsee%22ReinstallParallelsClient%22inSelfService." +
        "HowdoIgettherecommendedclient%3F",
);

const getDefaultLaunchProtocol = () => {
    return String(window.SETTINGS?.defaultLaunchProtocol ?? "");
};

const getDefaultLaunchProtocolBrowser = () => {
    return String(window.SETTINGS?.defaultLaunchProtocolBrowser ?? "");
};

export const Constants = {
    ResultTypes,
    MimeTypes,
    Headers,
    Protocols,
    ProtocolLabels,
    ProgressText,
    DefaultProgressText,
    MigrationFaqUrl,
    get DefaultLaunchProtocol() {
        return getDefaultLaunchProtocol();
    },
    get DefaultLaunchProtocolBrowser() {
        return getDefaultLaunchProtocolBrowser();
    },
};
